export const homeObjOne = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Welcome",
  headline:
    "Thank you for entering the world of CooMBaaH!! Wonderful music inspired by Sierra Leone ",
  description: `CooMBaaH formally known as Triple C is a Sierra Leonean artist based in the United Kingdom with strong ties to Germany. Born in the East Ends of Freetown, Sierra Leone, he moved to Berlin, Germany at a very early age where he completed his education and moved to Newcastle United Kingdom to study music. 
  After completing his studies, he moved to London to pursue his musical career. 
    `,
  buttonLabel: "Booking Enquiry",
  endlink: "/bookings",
  imgStart: "",
  img: "images/Main-image.jpg",
  alt: "Credit Card",
  redirect: false,
};

export const homeObjTwo = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "OUT NOW",
  headline: "AKPOOH",
  description:
    "Akpooh is an infectious blend of modern production and traditional Sierra Leonean rhythms, guaranteed to lift your mood. It's more than music—it’s pure energy performed in the heart of the motherland's languages. Performed by: CooMBaaH and Jimmy Jombla (Hinga) in Krio and Mende and Produced by: CooMBaaH and Mr Dalton Roberts aka Jazz Man Roberts",
  buttonLabel: "Listen Now",
  endlink:
    "https://www.youtube.com/watch?v=T-XW0TUEXeA&list=RDMMT-XW0TUEXeA&start_radio=1",
  imgStart: "",
  img: "images/AKPOOH-V4-1-Enhanced-2.jpg",
  alt: "Vault",
  redirect: true,
};

export const homeObjThree = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Previous Release",
  headline: "Motherland",
  description:
    "This project is inspired by the song Sina Makosa by Les Wanyika, its a collaboration with Frederik Nnaji (Nnaji). The song is produced by CooMBaaH and Dalton Roberts. It is written and performed by CooMBaaH and Nnaji.",
  buttonLabel: "Listen Now",
  endlink: "https://www.youtube.com/watch?v=0aZRJVhtCKQ",
  imgStart: "start",
  img: "images/MOTHERLAND square4.jpg",
  alt: "Vault",
  redirect: true,
};

export const homeObjFour = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Previous Release",
  headline: "Hard 4 Me",
  description:
    "This project is produced by Twano Cherry (DJ TC) in Berlin Germany, its written and performed by popular Reggae and R&B singer Denham Smith and CooMBaaH",
  buttonLabel: "Listen Now",
  endlink: "https://www.youtube.com/watch?v=Ia81gnvZSI0",
  imgStart: "",
  img: "images/Hard-4-Me-Single-Cover.jpeg",
  alt: "Vault",
  redirect: true,
};
